<template lang="pug">
  .phone
    .number
      p {{ $t('edit_profile.number') }} ({{ $t('edit_profile.half') }}) *
      input(
        :class="{ 'red-bordered': v_errors.first(`number-${index}`) }"
        v-model="phone.number"
        v-validate="'required|numeric'"
        :name="`number-${index}`"
        type="number"
      )
    .extension
      p {{ $t('edit_profile.extension') }} ({{ $t('edit_profile.half') }})
      input(
        v-model="phone.extension"
        type="number"
      )
    div.actions
      .delete-phone(v-if="existsPhone")
        button.delete-button(
          v-if="deleteCondition(phone)"
          @click="switchExistsPhoneState(1, phone)"
        ) Delete
        button.delete-button(
          v-if="returnCondition(phone)"
          @click="switchExistsPhoneState(0, phone)"
        ) Return
      .delete-phone(v-else)
        button.delete-button(
          @click="deleteNewPhone(phone)"
        ) Delete
</template>

<script>
  import { groupBy, values, some } from 'lodash'

  export default {
    props: {
      phone: {
        type: Object,
        default() {
          return {}
        }
      },

      index: {
        type: Number,
        default: null
      },

      existsPhone: {
        type: Boolean,
        default: false
      },

      allPhones: {
        type: Array,
        default() {
          return []
        }
      }
    },

    computed: {
      isDuplicatedPhones() {
        const groupped = groupBy(this.allPhones, values)
        return some(values(groupped), ({ length }) => length > 1)
      }
    },

    methods: {
      deleteCondition(phone) {
        return !phone._destroy
      },

      returnCondition(phone) {
        return phone._destroy == 1
      },

      switchExistsPhoneState(value, phone) {
        this.$emit('switchExistsPhoneState', { value, phone })
      },

      deleteNewPhone(phone) {
        this.$emit('deleteNewPhone', phone)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .phone {
    display: flex;

    .number,
    .extension {
      margin-right: 5px;
      width: 280px;
    }

    input {
      border: 1px solid #dfe6ee;
      border-radius: 4px;
      color: #313541;
      font-size: 14px;
      font-weight: 500;
      height: 40px;
      padding: 10px 12px;
      width: 280px;
    }

    button {
      background-color: transparent;
      border: 0;
      color: #008bd0;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
    }

    .actions {
      align-items: flex-end;
      display: flex;

      .delete-phone {
        .delete-button {
          height: 40px;
        }
      }
    }
  }
</style>
